"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlterationSourceType = void 0;
var AlterationSourceType;
(function (AlterationSourceType) {
    AlterationSourceType["IMPORT"] = "import";
})(AlterationSourceType = exports.AlterationSourceType || (exports.AlterationSourceType = {}));
//# sourceMappingURL=alteration-source-type.enum.js.map